import type { raSupabaseEnglishMessages } from "ra-supabase-language-english";

export const dutchSupabaseMessages = {
  "ra-supabase": {
    auth: {
      email: "E-mail",
      confirm_password: "Bevestig wachtwoord",
      sign_in_with: "Inloggen met %{provider}",
      forgot_password: "Wachtwoord vergeten?",
      reset_password: "Wachtwoord resetten",
      password_reset:
        "Controleer je e-mail voor een bericht om je wachtwoord te resetten.",
      missing_tokens: "Access- en refresh-tokens ontbreken",
      back_to_login: "Terug naar inloggen",
    },
    reset_password: {
      forgot_password: "Wachtwoord vergeten?",
      forgot_password_details:
        "Vul je e-mail in om een resetlink te ontvangen.",
    },
    set_password: {
      new_password: "Kies een wachtwoord",
    },
    validation: {
      password_mismatch: "Wachtwoorden komen niet overeen",
    },
  },
} satisfies typeof raSupabaseEnglishMessages;
